document.addEventListener('DOMContentLoaded', function () {
  const originalButton = document.querySelector('button[name="add"]');
  if (!originalButton || window.innerWidth > 749) return;

  if (document.querySelector('.sticky-atc')) return;

  const stickyBar = document.createElement('div');
  stickyBar.className = 'sticky-atc';
  stickyBar.innerHTML = '<button type="button" class="sticky-atc__button">Agregar al carrito</button>';
  document.body.appendChild(stickyBar);

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      stickyBar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });

  observer.observe(originalButton);

  stickyBar.querySelector('.sticky-atc__button').addEventListener('click', function () {
    originalButton.click();
  });
});